import { type CampaignStatus, type PostStatus } from './types'

/**
 * The post statuses
 * @constant
 */

export const POST_STATUSES: Record<PostStatus, PostStatus> = {
  CREATED: 'CREATED',
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  PUBLISHING: 'PUBLISHING',
  PROCESSING: 'PROCESSING',
  SENT: 'SENT',
  FAILED: 'FAILED',
}

/**
 * The campaign statuses
 * @constant
 */

export const CAMPAIGN_STATUSES: Record<CampaignStatus, CampaignStatus> = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  DELETED: 'DELETED',
}

export enum CaptionType {
  Manual = 'MANUAL',
  Ai = 'AI',
}

export enum ProductRuleType {
  Collections = 'COLLECTIONS',
  Tags = 'TAGS',
}
